// extracted by mini-css-extract-plugin
module.exports = {"container":"YoutubePrivacyPolicyContent_container__VDAKo"};